import React, { createContext, useState, useContext } from 'react';

const SyncStatusContext = createContext();

export const useSyncStatus = () => {
  const context = useContext(SyncStatusContext);
  if (!context) {
    throw new Error('useSyncStatus must be used within a SyncStatusProvider');
  }
  return context;
};

export const SyncStatusProvider = ({ children }) => {
  const [syncStatus, setSyncStatus] = useState({
    isSyncing: false,
    message: '',
    progress: 0,
    total: 0
  });

  const startSync = (message = 'Syncing activities...') => {
    setSyncStatus({
      isSyncing: true,
      message,
      progress: 0,
      total: 0
    });
  };

  const updateProgress = (progress, total, message) => {
    setSyncStatus(prev => ({
      ...prev,
      progress,
      total,
      message: message || prev.message
    }));
  };

  const completeSync = (message = 'Sync completed!') => {
    setSyncStatus({
      isSyncing: false,
      message,
      progress: 0,
      total: 0
    });

    // Clear message after 3 seconds
    setTimeout(() => {
      setSyncStatus(prev => ({
        ...prev,
        message: ''
      }));
    }, 3000);
  };

  const errorSync = (message = 'Sync failed') => {
    setSyncStatus({
      isSyncing: false,
      message,
      progress: 0,
      total: 0
    });

    // Clear message after 5 seconds
    setTimeout(() => {
      setSyncStatus(prev => ({
        ...prev,
        message: ''
      }));
    }, 5000);
  };

  const value = {
    syncStatus,
    startSync,
    updateProgress,
    completeSync,
    errorSync
  };

  return (
    <SyncStatusContext.Provider value={value}>
      {children}
    </SyncStatusContext.Provider>
  );
};
